import io from 'socket.io-client'
import { useAuthStore } from 'features/auth/store/authStore'

export const socketInstance = io(process.env.REACT_APP_API_BASE_URL, {
  autoConnect: false,
})

let currentToken = null

const joinUserRoom = () => {
  try {
    const state = useAuthStore.getState()
    const userId = state?.id || state?.user?.id || state?.user?._id

    if (!userId || !socketInstance.connected) return

    socketInstance.emit('init', {
      userId: userId.toString(),
      dealerCode: null,
    })
  } catch (error) {
    // ignore init errors — socket will retry on reconnect
  }
}

const connectWithToken = (token) => {
  if (!token) return
  currentToken = token
  if (socketInstance.connected) socketInstance.disconnect()
  socketInstance.auth = { token }
  socketInstance.connect()
}

// If token is already hydrated in store on module evaluation, connect immediately
const initialToken = useAuthStore.getState()?.token
if (initialToken) {
  connectWithToken(initialToken)
}

useAuthStore.subscribe((state) => {
  const token = state?.token
  if (token && token !== currentToken) {
    connectWithToken(token)
  }

  if (!token && currentToken) {
    currentToken = null
    socketInstance.disconnect()
  }

  if (state?.id || state?.user?.id || state?.user?._id) {
    joinUserRoom()
  }
})

socketInstance.on('connect', () => {
  joinUserRoom()
})

socketInstance.on('connect_error', async (error) => {
  if (
    error?.message?.includes('Authentication') ||
    error?.message?.includes('jwt') ||
    error?.message?.includes('token')
  ) {
    try {
      await useAuthStore.getState().fetchProfile(true)
      const freshToken = useAuthStore.getState()?.token
      if (freshToken && freshToken !== currentToken) {
        connectWithToken(freshToken)
      }
    } catch (e) {
      // Re-authentication will retry on next user action
    }
  }
})
